import React from 'react';
import { FieldTable } from '../../../components/FieldTable/FieldTable';
import { FieldTableColumnProps } from '../../../components/FieldTable/FieldTableTypes';
import { SiteMaintenanceInspection } from '../../../generated/graphql';
import { SiteMaintenanceInspectionSelect } from '../../../components/MaterialSelects/SiteMaintenanceInspectionSelect';

const columns: FieldTableColumnProps<SiteMaintenanceInspection>[] = [
    {
        header: 'Type',
        accessor: 'siteMaintenanceInspectionType',
        sort: 'rentalType.label',
        dataType: 'select',
        options: {
            label: 'label',
            renderEditor: ({ field }) =>
                <SiteMaintenanceInspectionSelect {...field} />
        }
    }, {
        header: 'Notes',
        accessor: 'notes',
        dataType: 'text',
    }, {
        header: 'Inspection Date',
        accessor: 'last_inspection_date',
        dataType:'date'
    }
];

interface MaintenenceAndInspectionPaneProps {
    values?: any;
    setValue?: (...args: any[]) => void;
    onChange?: (evt: any) => void;
    loading?: boolean;
    readOnly?: boolean;
}
const MaintenenceAndInspectionPane = ({ values, setValue, onChange, loading, readOnly }: MaintenenceAndInspectionPaneProps) => {
    return (
        <FieldTable columns={columns}
            name="siteMaintenanceInspection"
            values={values}
            setValue={setValue}
            className="site-build-and-repairs"
            readOnly={readOnly}
            newRowLabel="Add Maintenance &amp; Inspection"
        ></FieldTable>
    );
}


export default MaintenenceAndInspectionPane;

